import { userHasPermission, userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  messageInsurer: ({ user }) => {
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return true;
    }

    return false;
  },

  forward: ({ user, communication }) => {
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return (
        communication.sent_at &&
        (communication.type === "insurer_email" ||
          communication.type === "tenant_message" ||
          communication.type === "customer_message")
      );
    }

    return false;
  },

  remind: ({ user, communication }) => {
    return true;
  },

  createEmail: ({ user }) => {
    if (userHasRole(user, ["sysadmin", "accredo", "accredo_buchungsexport"])) {
      return true;
    }

    return false;
  },

  updateSubject: ({ user, communication }) => {
    return userHasPermission(user, "communication.all.write");
  },
};
